import { resetApplicationFacets } from './ymm-lookup.js';
import { escapeHtml } from '../core/utilities.js';

export function initEngineLookup() {
    var engineMfr = $('[data-set-engine-mfr]').attr('data-set-engine-mfr');
    var engineFamily = $('[data-set-engine-family]').attr(
        'data-set-engine-family'
    );
    var engineSize = $('[data-set-engine-size]').attr('data-set-engine-size');
    var engineSizeName = null;
    var $engineDropdownMfr = $('.engine-dropdown-mfr');
    var $engineDropdownFamily = $('.engine-dropdown-family');
    var $engineDropdownSize = $('.engine-dropdown-size');
    var $engineRecentSearch = $('.engine-dropdown-recent-search');
    var $engineForm = $('.engine-form');

    if (
        typeof engineMfr !== typeof undefined &&
        engineMfr !== null &&
        engineMfr != '' &&
        typeof engineFamily !== typeof undefined &&
        engineFamily !== null &&
        engineFamily != '' &&
        typeof engineSize !== typeof undefined &&
        engineSize !== null &&
        engineSize != ''
    ) {
        $engineForm.find('[type="submit"]').prop('disabled', false);
    }

    loadEngineFamiliesAndSizes();

    $engineDropdownMfr.change(function (e) {
        resetApplicationFacets();

        if (engineMfr != $(this).val()) {
            engineFamily = '';
            engineSize = '';
            engineMfr = $(this).val();
        }

        if (engineMfr != '') {
            loadEngineFamiliesAndSizes();
        } else {
            $engineDropdownFamily
                .html('<option value="">Engine Family</option>')
                .prop('disabled', true);
            $engineDropdownSize
                .html('<option value="">Engine Size</option>')
                .prop('disabled', true);
        }

        checkEngineFamilyForm();
    });

    $engineDropdownFamily.change(function (e) {
        resetApplicationFacets();
        engineFamily = $(this).val();

        if (engineMfr != '' && engineFamily != '') {
            loadEngineSizes();
        }

        checkEngineFamilyForm();
    });

    $engineDropdownSize.change(function (e) {
        resetApplicationFacets();
        engineSize = $(this).val();
        engineSizeName = $(this).find('option:selected').text();
        if (engineMfr != '' && engineSize != '') {
            loadEngineFamilies();
        }

        checkEngineFamilyForm();
    });

    // The engine form is not a .ymm-form, so the recent-search handler in ymm-lookup.js never
    // reached it and picking a past engine did nothing at all. Submitting posts vehicle[RowID]
    // and the server resolves that straight to the saved fitment, so the three selects only
    // have to show the shopper what they picked - and let checkEngineFamilyForm() enable
    // Search. The option carries the saved ids, so loadEngineFamiliesAndSizes() can refill the
    // family and size lists with them already selected.
    $engineForm.on('change', '.engine-dropdown-recent-search', function () {
        var $selected = $(this).find('option:selected');

        resetApplicationFacets();

        engineMfr = $selected.attr('data-engine-mfr') || '';
        engineFamily = $selected.attr('data-engine-family') || '';
        engineSize = $selected.attr('data-engine-size') || '';
        engineSizeName = null;

        $engineDropdownMfr.val(engineMfr);

        if (engineMfr != '') {
            loadEngineFamiliesAndSizes();
        } else {
            $engineDropdownFamily
                .html('<option value="">Engine Family</option>')
                .prop('disabled', true);
            $engineDropdownSize
                .html('<option value="">Engine Size</option>')
                .prop('disabled', true);
        }

        checkEngineFamilyForm();
    });

    // Model_vehicle::getCurrentVehicle() prefers a posted RowID over the posted ids, so a
    // recent search left selected would quietly override whatever the shopper picks by hand
    // afterwards. Building a fitment by hand means they are no longer re-running a past one.
    $engineForm.on(
        'change',
        '.engine-dropdown-mfr, .engine-dropdown-family, .engine-dropdown-size',
        function () {
            $engineRecentSearch.val('');
        }
    );

    $engineForm.submit(function (e) {
        setEngineNames($(this));
    });

    function checkEngineFamilyForm() {
        var disabled = true;

        if (engineMfr != '' && engineFamily != '' && engineSize != '') {
            disabled = false;
        }

        $engineForm.find('[type="submit"]').prop('disabled', disabled);
    }

    function loadEngineFamiliesAndSizes() {
        if (
            typeof engineMfr !== typeof undefined &&
            engineMfr !== null &&
            engineMfr != ''
        ) {
            $.ajax({
                url: '/ymm/get_engine_family_size/' + engineMfr,
                type: 'get',
                dataType: 'json',
                success: function (response) {
                    if (
                        typeof engineSize !== typeof undefined &&
                        engineSize !== null &&
                        engineSize != ''
                    ) {
                        loadEngineFamilies();
                    } else if (response.hasOwnProperty('engine_families')) {
                        var output = '<option value="">Engine Family</option>';

                        for (
                            var i = 0;
                            i < response.engine_families.length;
                            i++
                        ) {
                            output +=
                                '<option value="' +
                                escapeHtml(response.engine_families[i].id) +
                                '"' +
                                (engineFamily == response.engine_families[i].id
                                    ? ' selected="selected"'
                                    : '') +
                                '>' +
                                escapeHtml(response.engine_families[i].enginefamily) +
                                '</option>';
                        }

                        $engineDropdownFamily
                            .html(output)
                            .prop('disabled', false);
                    }

                    if (
                        typeof engineFamily !== typeof undefined &&
                        engineFamily !== null &&
                        engineFamily != ''
                    ) {
                        loadEngineSizes();
                    } else if (response.hasOwnProperty('engine_sizes')) {
                        var output = '<option value="">Engine Size</option>';

                        for (var i = 0; i < response.engine_sizes.length; i++) {
                            output +=
                                '<option value="' +
                                escapeHtml(response.engine_sizes[i].id) +
                                '"' +
                                (engineSize == response.engine_sizes[i].id
                                    ? ' selected="selected"'
                                    : '') +
                                '>' +
                                escapeHtml(response.engine_sizes[i].enginesize) +
                                '</option>';
                        }

                        $engineDropdownSize
                            .html(output)
                            .prop('disabled', false);
                    }
                },
                error: function (xhr, status, error) {
                    console.error(error);
                },
            });
        }
    }

    function loadEngineSizes() {
        if (engineMfr != '' && engineFamily != '') {
            $.ajax({
                url:
                    '/ymm/get_engine_sizes/' +
                    engineMfr +
                    '/' +
                    engineFamily,
                type: 'get',
                dataType: 'json',
                success: function (response) {
                    var output = '<option value="">Engine Size</option>';

                    for (var i = 0; i < response.length; i++) {
                        output +=
                            '<option value="' +
                            escapeHtml(response[i].id) +
                            '"' +
                            (response[i].id == engineSize || response[i].enginesize == engineSizeName
                                ? ' selected="selected"'
                                : '') +
                            '>' +
                            escapeHtml(response[i].enginesize) +
                            '</option>';
                    }

                    $engineDropdownSize.html(output).prop('disabled', false);
                },
                error: function (xhr, status, error) {
                    console.error(error);
                },
            });
        }
    }

    function loadEngineFamilies() {
        if (engineMfr != '' && engineSize != '') {
            $.ajax({
                url:
                    '/ymm/get_engine_families/' +
                    engineMfr +
                    '/' +
                    engineSize,
                type: 'get',
                dataType: 'json',
                success: function (response) {
                    var output = '<option value="">Engine Family</option>';

                    for (var i = 0; i < response.length; i++) {
                        output +=
                            '<option value="' +
                            escapeHtml(response[i].id) +
                            '"' +
                            (response[i].id == engineFamily
                                ? ' selected="selected"'
                                : '') +
                            '>' +
                            escapeHtml(response[i].enginefamily) +
                            '</option>';
                    }

                    $engineDropdownFamily.html(output).prop('disabled', false);
                },
                error: function (xhr, status, error) {
                    console.error(error);
                },
            });
        }
    }

    function setEngineNames($form) {
        if ($form.find('.engine-dropdown-mfr').val().length) {
            $form
                .find('[name="vehicle[EngineMfrName]"]')
                .val($form.find('.engine-dropdown-mfr option:selected').text());
        }

        if ($form.find('.engine-dropdown-family').val().length) {
            $form
                .find('[name="vehicle[EngineFamilyName]"]')
                .val(
                    $form.find('.engine-dropdown-family option:selected').text()
                );
        }

        if ($form.find('.engine-dropdown-size').val().length) {
            $form
                .find('[name="vehicle[EngineSizeName]"]')
                .val(
                    $form.find('.engine-dropdown-size option:selected').text()
                );
        }
    }
}
